import { render, staticRenderFns } from "./onebox-landingpage.vue?vue&type=template&id=75b70d5b&scoped=true&"
import script from "./onebox-landingpage.vue?vue&type=script&lang=js&"
export * from "./onebox-landingpage.vue?vue&type=script&lang=js&"
import style0 from "./onebox-landingpage.vue?vue&type=style&index=0&id=75b70d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b70d5b",
  null
  
)

export default component.exports